<template>

<div class="flex w-full justify-center space-x-2">
    <button
      v-if="recordingState === 'previewing'"
      @click="onStart"
      type="submit"
      class="inline-flex items-center px-4 py-3 mb-1 text-base font-medium text-black bg-white border rounded-full shadow-sm border-sw-light-grey drop-shadow-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
    >
      <span class="text-red-600 w-auto pr-2">
        <FontAwesomeIcon
          class="h-4"
          :icon="faClapperboard"
          alt="record button"
        />
      </span>
      Start Recording
    </button>

    <button
      v-if="recordingState === 'paused'"
      @click="onResume"
      class="inline-flex items-center rounded-full border border-transparent bg-white px-6 py-3 text-base font-medium text-red-600 shadow-sm drop-shadow-md hover:border hover:border-solid hover:border-red-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2"
    >
      <span class="text-red-600 w-auto pr-2">
        <FontAwesomeIcon
          class="h-4"
          :icon="faClapperboard"
          alt="record button"
        />
      </span>
      &nbsp;Record
    </button>

    <button
      v-if="recordingState === 'recording'"
      @click="onPause"
      class="hover:border inline-flex items-center rounded-full border border-transparent bg-white px-6 py-3 text-base font-medium text-gray-600 shadow-sm drop-shadow-md hover:border-solid hover:border-red-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2"
    >
      <PauseIcon class="h-6 w-6 rounded-full bg-white p-1 text-gray-600" />
      &nbsp;{{ pauseLabel }}
    </button>

    <button
      v-if="recordingState === 'recording' || recordingState === 'paused'"
      @click="onStop"
      class="inline-flex items-center rounded-full border border-transparent bg-red-600 px-6 py-3 text-base font-medium text-white shadow-sm drop-shadow-md hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2"
    >
      <StopIcon class="h-4 w-4 rounded-full bg-white p-1 text-red-600" />
      &nbsp;Done
    </button>
</div>

</template>

<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faClapperboard } from "@fortawesome/pro-solid-svg-icons";
import { PauseIcon, StopIcon } from "@heroicons/vue/24/solid";
import { defineProps } from "vue";

const props = defineProps({
  recordingState: String,
  onStart: Function,
  onPause: Function,
  onResume: Function,
  onStop: Function,
  pauseLabel: {
    type: String,
    default: "Pause",
  },
});
</script>
